import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'splash',
  templateUrl: './splash.component.html',
  styleUrls: ['./splash.component.scss']
})
export class SplashComponent implements OnInit {

  public activeTyping = 1;

  constructor() { }

  ngOnInit() {
  }

  scrollToInfo(): void {
    var infoDoc = document.getElementById("splash-zone-2").offsetTop;
    infoDoc -= 50;
    window.scroll({ top: infoDoc, behavior: 'smooth' });
  }

  completedType(next) {
    if (next != 1){
      setTimeout(() => {
        this.activeTyping = next;
      }, 1500);
    }
  }

}



// WEBPACK FOOTER //
// /Users/cullenkirkpatrick/Documents/Goals/goal-project/src/app/splash/splash.component.ts